import { SelectionCombination } from '../../../components/SelectedCombination';
import styles from './styles.module.css';
import { AdditionalChecks } from '../../../components/AsideMenuSelection/components/AdditionalChecks';
import SelectionMenuBase from '../../../components/SelectionMenuBase/SelectionMenuBase';
import React, { useEffect, useState } from 'react';
import { DealTaxesInfo } from './DealTaxesInfo';
import { SelectedItem } from '../../../components/SelectionPopup/SelectionPopup';
import { Icons } from '../../../components/Icon/Icon';
import AsideMenuSelectionMenuGroup, {
    asideMenuSelectionMenuGroups,
} from '../../../components/AsideMenuSelection/AsideMenuSelectionMenuGroup';

const DealTaxesAsideMenu = ({
    isOptimisation,
    selectedData,
    setSelectedInvestor,
    onEdit,
    active,
    setActive,
    hidden,
    infoProps,
    checksProps,
    backButton,
}: any) => {
    const [openCategory, setOpenCategory] = useState<undefined | string>(asideMenuSelectionMenuGroups.selection);
    const [contentHeight, setContentHeight] = useState(900);

    useEffect(() => {
        setContentHeight(
            770 +
                80 * selectedData.investors.length +
                20 * selectedData.assets.length +
                (selectedData.fundOfFunds ? 200 : 0),
        );
    }, [selectedData]);

    const toggleCategory = (category: any) => {
        setOpenCategory(openCategory === category ? undefined : category);
    };

    const handleSelectedInvestor = (id: number) => () => {
        setSelectedInvestor(selectedData.investors.find((investor: SelectedItem) => investor.id === id));
    };

    return (
        <SelectionMenuBase
            info={<DealTaxesInfo {...infoProps} />}
            active={active}
            setActive={setActive}
            hidden={hidden}
        >
            <div className={styles.mainInfo}>
                <AsideMenuSelectionMenuGroup
                    icon={Icons.chevronDownFilled}
                    label={!isOptimisation ? 'Initial inputs' : 'Proposed structure'}
                    setOpenCategory={toggleCategory}
                    openCategory={openCategory}
                    category={asideMenuSelectionMenuGroups.selection}
                    contentHeight={contentHeight}
                    onEdit={!isOptimisation ? onEdit : undefined}
                    backButton={backButton}
                    isOptimisation={isOptimisation}
                >
                    <SelectionCombination
                        selectedData={selectedData}
                        isOptimisation={isOptimisation}
                        hideFundRow={false}
                        isSelectable={!isOptimisation}
                        handleSelectedInvestor={handleSelectedInvestor}
                    />
                </AsideMenuSelectionMenuGroup>

                {!isOptimisation && (
                    <AsideMenuSelectionMenuGroup
                        icon={Icons.chevronDownFilled}
                        label={'Further selection'}
                        openCategory={openCategory}
                        setOpenCategory={toggleCategory}
                        category={
                            selectedData.fundOfFunds
                                ? asideMenuSelectionMenuGroups.checkboxesGrouped
                                : asideMenuSelectionMenuGroups.checkboxes
                        }
                        contentHeight={contentHeight}
                    >
                        <AdditionalChecks {...checksProps} />
                    </AsideMenuSelectionMenuGroup>
                )}
            </div>
        </SelectionMenuBase>
    );
};

export default DealTaxesAsideMenu;
